import { EMPTY_VALUE, Money, formatMoney } from '@betterment/core';

import { PayrollContributionRate } from '~/graphql/schema';

export function percentToString(value: number) {
  return value.toFixed(1);
}

export function amountToString(value: Money) {
  return formatMoney(value).replace(/^(-)?\$/, '$1');
}

export function formatMoneySafe(value: Money | null | undefined): string {
  return value != null ? formatMoney(value) : EMPTY_VALUE;
}

export function payrollContributionRateToString(rate: PayrollContributionRate) {
  switch (rate.__typename) {
    case 'PayrollContributionPercent':
      return percentToString(rate.percent);
    case 'PayrollContributionAmount':
      return amountToString(rate.amount);
    default:
      throw TypeError('Unexpected type name on union type.');
  }
}
